import { render, staticRenderFns } from "./PercentageVoucherType.vue?vue&type=template&id=bc6e62e0&scoped=true"
import script from "./PercentageVoucherType.vue?vue&type=script&lang=js"
export * from "./PercentageVoucherType.vue?vue&type=script&lang=js"
import style0 from "./PercentageVoucherType.vue?vue&type=style&index=0&id=bc6e62e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6e62e0",
  null
  
)

export default component.exports